import { render, staticRenderFns } from "./Sort.vue?vue&type=template&id=151d4b63&scoped=true&"
import script from "./Sort.vue?vue&type=script&lang=ts&"
export * from "./Sort.vue?vue&type=script&lang=ts&"
import style0 from "./Sort.vue?vue&type=style&index=0&id=151d4b63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151d4b63",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VChip,VChipGroup,VDialog})
